var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5259_7385)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33317 5.54297C8.32756 5.54297 7.36313 5.94245 6.65206 6.65352C5.94098 7.3646 5.5415 8.32902 5.5415 9.33463V18.668C5.5415 19.6736 5.94098 20.638 6.65206 21.3491C7.36313 22.0602 8.32756 22.4596 9.33317 22.4596H18.6665C19.6721 22.4596 20.6365 22.0602 21.3476 21.3491C22.0587 20.638 22.4582 19.6736 22.4582 18.668V9.33463C22.4582 8.32902 22.0587 7.3646 21.3476 6.65352C20.6365 5.94245 19.6721 5.54297 18.6665 5.54297H9.33317ZM5.41462 5.41608C6.45388 4.37682 7.86343 3.79297 9.33317 3.79297H18.6665C20.1362 3.79297 21.5458 4.37682 22.5851 5.41608C23.6243 6.45535 24.2082 7.86489 24.2082 9.33463V18.668C24.2082 20.1377 23.6243 21.5473 22.5851 22.5865C21.5458 23.6258 20.1362 24.2096 18.6665 24.2096H9.33317C7.86343 24.2096 6.45388 23.6258 5.41462 22.5865C4.37536 21.5473 3.7915 20.1377 3.7915 18.668V9.33463C3.7915 7.86489 4.37536 6.45535 5.41462 5.41608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9064 10.9064C11.7269 10.0859 12.8397 9.625 14 9.625C15.1603 9.625 16.2731 10.0859 17.0936 10.9064C17.9141 11.7269 18.375 12.8397 18.375 14C18.375 15.1603 17.9141 16.2731 17.0936 17.0936C16.2731 17.9141 15.1603 18.375 14 18.375C12.8397 18.375 11.7269 17.9141 10.9064 17.0936C10.0859 16.2731 9.625 15.1603 9.625 14C9.625 12.8397 10.0859 11.7269 10.9064 10.9064ZM14 11.375C13.3038 11.375 12.6361 11.6516 12.1438 12.1438C11.6516 12.6361 11.375 13.3038 11.375 14C11.375 14.6962 11.6516 15.3639 12.1438 15.8562C12.6361 16.3484 13.3038 16.625 14 16.625C14.6962 16.625 15.3639 16.3484 15.8562 15.8562C16.3484 15.3639 16.625 14.6962 16.625 14C16.625 13.3038 16.3484 12.6361 15.8562 12.1438C15.3639 11.6516 14.6962 11.375 14 11.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 7.875C19.7332 7.875 20.125 8.26675 20.125 8.75V8.76167C20.125 9.24492 19.7332 9.63667 19.25 9.63667C18.7668 9.63667 18.375 9.24492 18.375 8.76167V8.75C18.375 8.26675 18.7668 7.875 19.25 7.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5259_7385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.96cf35c1ecc0d23a7d164c48a8bcc12d.svg";
export { ForwardRef as ReactComponent };